import React, { useState, useEffect,useRef } from "react";

const ChatGPTTypingEffect = ({ text, speed = 200 }) => {
  const words = text?.split(" ");
  const [displayedText, setDisplayedText] = useState("");
  const [index, setIndex] = useState(0);
  const chatEndRef = useRef(null);
  useEffect(() => {
    if (index < words.length) {
      const timeout = setTimeout(() => {
        setDisplayedText((prev) => prev + " " + words[index]);
        setIndex(index + 1);
      }, speed);

      return () => clearTimeout(timeout);
    }
  }, [index, words, speed]);

  useEffect(() => {
    chatEndRef.current?.scrollIntoView({ behavior: "smooth" });
  }, [displayedText]);


  return  <div><div style={{ whiteSpace: "pre-line",width:'fit-content',padding:'10px 12px', background:'#F2F2F2', color:'#091E42', fontSize:'13px', fontWeight:'400',borderRadius:'20px 20px 20px 4px',textAlign:'left'}}>
           {displayedText}
  </div>
  <div ref={chatEndRef}></div>
  </div>;
};

export default ChatGPTTypingEffect;